var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSteam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2051 24.3472C45.2051 20.5898 42.1575 17.5421 38.4001 17.5421C34.6427 17.5421 31.595 20.5898 31.595 24.3472C31.595 28.1046 34.6427 31.1522 38.4001 31.1522C42.1575 31.1522 45.2051 28.1046 45.2051 24.3472ZM33.2127 24.3472C33.2127 21.4769 35.5403 19.1494 38.4105 19.1494C41.2807 19.1494 43.6082 21.4769 43.6082 24.3472C43.6082 27.2174 41.2807 29.5449 38.4105 29.5449C35.5403 29.5449 33.2127 27.2174 33.2127 24.3472Z",
    fill: "#010101"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1036 6C17.3633 6 6.94616 15.8247 6 28.2949L18.6748 33.6419C19.8177 32.838 21.2135 32.3706 22.7217 32.3706C22.881 32.3706 23.0402 32.3706 23.1901 32.3893L28.9233 24.0042C28.9233 18.9189 33.0545 14.7964 38.1506 14.7964C43.2467 14.7964 47.378 18.9189 47.378 24.0042C47.378 29.0894 43.2467 33.2119 38.1506 33.2119C38.0757 33.2119 38.0101 33.2119 37.9352 33.2119L29.7476 39.017C29.7476 39.1478 29.757 39.2694 29.757 39.4002C29.757 43.2796 26.6 46.4299 22.7123 46.4299C19.2556 46.4299 16.3703 43.9433 15.7801 40.6622L6.89934 37.0072C9.85959 47.0001 19.1151 54.2915 30.0942 54.2915C43.4622 54.2915 54.2915 43.4853 54.2915 30.1458C54.2915 16.8062 43.4622 6 30.0942 6H30.1036Z",
    fill: "#010101"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.001 45.7633C19.6337 45.7633 17.2644 44.5422 15.9285 43.9994C16.8469 45.9825 18.8509 47.3602 21.1784 47.3602C24.3722 47.3602 26.9606 44.7718 26.9606 41.578C26.9606 38.3842 24.3722 35.7958 21.1784 35.7958C20.4478 35.7958 19.7485 35.9315 19.1119 36.1819C21.7525 37.2987 25.2802 37.8832 25.2802 41.4945C25.2802 43.8533 23.3598 45.7738 21.001 45.7738V45.7633Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteam);
export default __webpack_public_path__ + "static/media/steam.742de986deceb64be5334eae741ad731.svg";
export { ForwardRef as ReactComponent };